import { promiseAction } from 'utils/store';

export const DASHBOARD_ACTION_TYPES = {
  LOAD_DASHBOARD_INFO: 'dashboard/LOAD_INFO',
  LOAD_DASHBOARD_INFO_PERIOD: 'dashboard/LOAD_INFO_PERIOD',
};

export const loadDashboard = promiseAction(DASHBOARD_ACTION_TYPES.LOAD_DASHBOARD_INFO);

export const loadDashboardPeriod = promiseAction(DASHBOARD_ACTION_TYPES.LOAD_DASHBOARD_INFO_PERIOD);